module.exports = __webpack_public_path__ + "img/60.7840506b.jpg";